import React from "react";
import Link from "next/link";
import Footer from "./Footer";
import { usePathname } from "../services/hooks/usePathname";

const Error = React.memo(({ statusCode, message }) => {
  const { pathname } = usePathname();

  return (
    <>
      <section className="py-12">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8 col-xl-6 text-center">
              <div className="mb-7 font-size-h1">🙁</div>

              <h2 className="mb-5">
                {statusCode
                  ? `${statusCode}. That's an error`
                  : "Oops! That's an error."}
              </h2>

              <p className="mb-7 text-gray-500">
                {message ||
                  `The requested URL ${pathname} was not found on this server. That’s all we know.`}
              </p>

              <Link href="/">
                <a className="btn btn-dark mr-2">Go Home</a>
              </Link>

              <Link href="/#subscribe">
                <a className="btn btn-outline-dark">Subscribe</a>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
});

export default Error;
